"use client"

import { useEffect, useState } from "react"
import { useRouter } from '@/platform/navigation'
import { useAuth } from "@/lib/auth-context"
import { Spinner } from "@/components/ui/spinner"

export default function AuthLayout({ children }: { children: React.ReactNode }) {
  const router = useRouter()
  const { user, loading } = useAuth()
  const [showSpinner, setShowSpinner] = useState(false)

  useEffect(() => {
    if (!loading && user) {
      router.replace("/dashboard")
    }
  }, [user, loading, router])

  useEffect(() => {
    if (loading || user) {
      const timer = setTimeout(() => setShowSpinner(true), 150)
      return () => clearTimeout(timer)
    } else {
      setShowSpinner(false)
    }
  }, [loading, user])

  if (loading || user) {
    if (!showSpinner) {
      return null
    }
    return (
      <div className="flex min-h-screen items-center justify-center">
        <Spinner className="h-6 w-6" />
      </div>
    )
  }

  return <>{children}</>
}
